'use strict';

angular.module('app.common')

.directive('gaSelectEventClick', ['GaService', '$route', 'DataService', '$location', function(gaService, $route, dataService, $location){
	return {
		restrict: 'A',
		require: 'ngModel',
		link:function(scope, element, attribute, controller){
			element.bind('change',function(e){
				var location = dataService.getCurrentLocation().locationCode;
				var itemVal;
				if(typeof controller.$viewValue === 'object') {
					itemVal = controller.$viewValue.name;
				} else {
					itemVal = controller.$viewValue;
				}
				gaService.gaTrackClickFromLinks(location + ' : ' + attribute['pagename'], attribute['criterianame'] + '/' + itemVal);
			});
		}
	}
}]);




// WEBPACK FOOTER //
// ./app/common/directives/ga/gaSelectEventClickDirective.js